<template>
  <div class="admin" v-if="isAuthenticated">
    <div class="admin-bar">
      <h1 class="admin-title">管理画面</h1>
      <nav class="tabs">
        <button class="tab" :class="{ active: showTab === 'news' }" @click="switchTab('news')">NEWS</button>
        <button class="tab" :class="{ active: showTab === 'event' }" @click="switchTab('event')">EVENTS</button>
        <button class="tab" :class="{ active: showTab === 'products' }" @click="switchTab('products')">PRODUCTS</button>
      </nav>
    </div>
    <div class="admin-body">
      <NewsRegist v-if="showTab === 'news'" />
      <EventRegist v-else-if="showTab === 'event'" />
      <ProductRegist v-else-if="showTab === 'products'" />
    </div>
  </div>
</template>

<script>
import NewsRegist from './NewsRegist.vue';
import EventRegist from './EventRegist.vue';
import ProductRegist from './ProductRegist.vue';
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default {
  name: 'Admin',
  components: {
    NewsRegist,
    EventRegist,
    ProductRegist
  },
  props: {
  },
  data() {
    return {
      showTab: 'news',
      isAuthenticated: false
    }
  },
  mounted() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.isAuthenticated = true;
      } else {
        this.$router.push('/signin-signup');
      }
    });
  },
  methods: {
    switchTab(target) {
      this.showTab = target
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.admin {
  --gold: #AF9453;
  --gold-dark: #937b3f;
}
.admin-bar {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px 8px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.admin-title {
  font-size: 20px;
  font-weight: 800;
  color: #3a3630;
  margin: 0;
}
.tabs {
  display: inline-flex;
  gap: 4px;
  background: #f0ece1;
  padding: 4px;
  border-radius: 12px;
}
.tab {
  padding: 9px 24px;
  border: none;
  background: transparent;
  border-radius: 9px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #6b6555;
  cursor: pointer;
  transition: color 0.15s, background 0.15s, box-shadow 0.15s;
}
.tab:hover {
  color: var(--gold-dark);
}
.tab.active {
  background: var(--gold);
  color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
}

@media screen and (max-width: 640px) {
  .admin-bar {
    justify-content: center;
  }
  .tabs {
    width: 100%;
  }
  .tab {
    flex: 1;
    padding: 9px 8px;
  }
}
</style>
